/**
 * FAQ Manager - Moon Moon Agency
 * FAQ load more functionality (multi-instance safe)
 */

/*********************************************************************************************
 * 🔧 FAQ MANAGER
 */
const FAQManager = {
	config: {
		selectors: {
			section: '[data-faq-section]',
			loadMore: '[data-faq-load-more]',
			hiddenItem: '[data-faq-hidden]',
		},
		classes: {
			visible: 'mm-faq__accordion-item--visible',
			loadMoreHidden: 'mm-faq__load-more--hidden',
		},
		boundFlag: 'faqLoadMoreBound',
	},

	init() {
		const sections = document.querySelectorAll(this.config.selectors.section);
		if (sections.length === 0) return;

		sections.forEach((section) => this._bindSection(section));
	},

	_bindSection(section) {
		const loadMoreBtn = section.querySelector(this.config.selectors.loadMore);
		if (!loadMoreBtn) return;
		if (loadMoreBtn.dataset[this.config.boundFlag] === 'true') return;

		const hiddenItems = section.querySelectorAll(this.config.selectors.hiddenItem);
		if (hiddenItems.length === 0) return;

		loadMoreBtn.dataset[this.config.boundFlag] = 'true';

		loadMoreBtn.addEventListener('click', () => {
			hiddenItems.forEach((item) => {
				item.classList.add(this.config.classes.visible);
			});
			loadMoreBtn.classList.add(this.config.classes.loadMoreHidden);
			loadMoreBtn.setAttribute('aria-expanded', 'true');
		});
	},
};

if (!window.FAQManager) {
	window.FAQManager = FAQManager;

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => window.FAQManager.init());
	} else {
		window.FAQManager.init();
	}
}
